<section class="dropdown profile-selector">
  <button class="btn dropdown-toggle" type="button" id="profileOptions" data-bs-toggle="dropdown" aria-expanded="false">
    <img class="profile-selector__img profile-selector__img--reduced" src="resources/img/icons/iconouser.png" alt="Language icon" />
  </button>
  <ul class="dropdown-menu" aria-labelledby="profileOptions">
    @if (!isLogged()) {
      <li>
        <button class="dropdown-item" routerLink="/user/login">
          {{ 'shared.header.users.login' | translate }}
        </button>
      </li>

      <li>
        <button class="dropdown-item" routerLink="/user/create-account">
          {{ 'shared.header.users.register' | translate }}
        </button>
      </li>
    } @else {
      <li>
        <button class="dropdown-item" routerLink="/user/profile">
          {{ 'shared.header.users.account' | translate }}
        </button>
      </li>

      <li>
        <button class="dropdown-item" routerLink="/badge">
          {{ 'shared.header.users.generateBadge' | translate }}
        </button>
      </li>

      <li>
        <button class="dropdown-item" (click)="onLogout()">
          {{ 'shared.header.users.logout' | translate }}
        </button>
      </li>
    }
  </ul>
</section>
